import store from '@/store'
import { v4 as uuidv4 } from 'uuid'

const DEFAULT_EVENT_SOURCE = 'website'
const CURRENCY_COP = 'COP'

export const COMPLETE_REGISTRATION_EVENT = 'CompleteRegistration'
export const SEARCH_EVENT = 'Search'
export const VIEW_CONTENT_EVENT = 'ViewContent'
export const ADD_TO_CART_EVENT = 'AddToCart'
export const INITIATE_CHECKOUT_EVENT = 'InitiateCheckout'
export const PURCHASE_EVENT = 'Purchase'

export const saveTrackingEvent = async ({ eventName, data }) => {
  if (process.env.VUE_APP_TRACKER_ENABLED !== 'true') {
    return
  }

  const track = processEvent[eventName]
  if (!track) {
    return
  }

  const eventID = uuidv4()

  const event = {
    event_id: eventID,
    event_name: eventName,
    event_time: new Date(),
    event_user: {
      user_agent: navigator.userAgent
    },
    event_source: DEFAULT_EVENT_SOURCE,
    event_source_url: window.location.href
  }

  track(event, data)
}

export const saveRegistrationEvent = async (event, { user }) => {
  // eslint-disable-next-line
  fbq('track', COMPLETE_REGISTRATION_EVENT, {
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name
  }, { event_id: event.event_id })

  event.event_user = {
    user_agent: navigator.userAgent,
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name
  }

  await store.dispatch('tracker/saveTrackingEvents', [event])
}

export const saveSearchEvent = async (event, { search }) => {
  // eslint-disable-next-line
  fbq('track', SEARCH_EVENT, { search_string: search }, { event_id: event.event_id })

  event.event_custom_data = {
    search
  }

  await store.dispatch('tracker/saveTrackingEvents', [event])
}

export const saveViewContentEvent = async (event, { name, price }) => {
  // eslint-disable-next-line
  fbq('track', VIEW_CONTENT_EVENT, {
    content_name: name,
    currency: CURRENCY_COP,
    value: price
  }, { event_id: event.event_id })

  event.event_custom_data = {
    content_name: name,
    currency: CURRENCY_COP,
    value: price
  }

  await store.dispatch('tracker/saveTrackingEvents', [event])
}

export const saveAddToCartEvent = async (event, { product }) => {
  // eslint-disable-next-line
  fbq('track', ADD_TO_CART_EVENT, {
    content_name: product.name,
    currency: CURRENCY_COP,
    value: product.price ?? product.variant.price
  }, { event_id: event.event_id })

  event.event_custom_data = {
    content_name: product.name,
    currency: CURRENCY_COP,
    value: product.price ?? product.variant.price
  }

  await store.dispatch('tracker/saveTrackingEvents', [event])
}

const getProductItems = (products) => {
  const items = []
  const contents = []

  for (const product of products) {
    items.push({
      id: product.product_id,
      quantity: product.quantity,
      value: product.price ?? product.variant.price
    })

    contents.push({
      id: product.product_id,
      quantity: product.quantity,
      item_price: product.price ?? product.variant.price
    })
  }

  return { items, contents }
}

export const saveInitiateCheckoutEvent = async (event, { order, price }) => {
  const { items, contents } = getProductItems(order.products)

  // eslint-disable-next-line
  fbq('track', INITIATE_CHECKOUT_EVENT, {
    contents,
    currency: CURRENCY_COP,
    value: price
  }, { event_id: event.event_id })

  event.event_custom_data = {
    items,
    currency: CURRENCY_COP,
    value: price,
    delivery_type: order.delivery.delivery_type
  }

  event.event_user.email = order.user.email ?? ''
  event.event_user.first_name = order.user.first_name ?? ''
  event.event_user.last_name = order.user.last_name ?? ''
  event.event_user.phone_number = order.user.phone_number ?? order.address.cell_phone ?? ''

  await store.dispatch('tracker/saveTrackingEvents', [event])
}

export const savePurchaseEvent = async (event, { order, price }) => {
  const { items, contents } = getProductItems(order.products)

  // eslint-disable-next-line
  fbq('track', PURCHASE_EVENT, {
    contents,
    currency: CURRENCY_COP,
    value: price
  }, { event_id: event.event_id })

  event.event_custom_data = {
    items,
    currency: CURRENCY_COP,
    value: price,
    delivery_type: order.delivery.delivery_type
  }

  event.event_user.email = order.user.email ?? ''
  event.event_user.first_name = order.user.first_name ?? ''
  event.event_user.last_name = order.user.last_name ?? ''
  event.event_user.phone_number = order.user.phone_number ?? order.address.cell_phone ?? ''

  await store.dispatch('tracker/saveTrackingEvents', [event])
}

const processEvent = {
  [COMPLETE_REGISTRATION_EVENT]: saveRegistrationEvent,
  [SEARCH_EVENT]: saveSearchEvent,
  [VIEW_CONTENT_EVENT]: saveViewContentEvent,
  [ADD_TO_CART_EVENT]: saveAddToCartEvent,
  [INITIATE_CHECKOUT_EVENT]: saveInitiateCheckoutEvent,
  [PURCHASE_EVENT]: savePurchaseEvent
}
